import type { PrizeType } from '../enums/PrizeType'

export class PrizeFilterEntity {
  searchWord?: string
  type?: PrizeType
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
